// PartnerGroup is declared in ./partner-models together with the types it is mutually recursive
// with. This shim keeps the original import path working - see partner-models.ts.
export { PartnerGroup } from './partner-models';
